/**
 * Smatchy
 * The smatchy API description. Use POST /auth/login to get an access token.
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface UserSportTypeLevel {
    answerSentence?: string;
    sportId: string;
    /**
     * The discipline this level is for (= session-kind id). Absent on sports
     * assessed as a whole; set on per-discipline sports like ski.
     */
    disciplineId?: string;
    date: string;
    answers?: Array<object>;
    level?: number;
}

